import React from 'react';
import { cartOutline } from 'ionicons/icons';
import { IonBadge } from '@ionic/react';
import IconButton from '../../../components/common/IconButton/IconButton';
import './CartButton.css';

interface Props {
    count: number;
    onClick?: () => void;
    routerLink?: string;
    slot?: string;
}

const CartButton: React.FC<Props> = ({ count, onClick, routerLink, slot = 'end' }) => {
    return (
        <div className="cart-button-wrapper" slot={slot}>
            <IconButton
                icon={cartOutline}
                onClick={onClick}
                routerLink={routerLink}
                color="primary"
            />
            {count > 0 && (
                <IonBadge color="danger" className="cart-badge">
                    {count}
                </IonBadge>
            )}
        </div>
    );
};

export default CartButton;
